import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loggedInUser: undefined,
    currentGame: null,
    isFullScreen: false
  },
  getters: {
    loggedInUser(state) {
      return state.loggedInUser
    },
    currentGame(state) {
      return state.currentGame;
    },
    isFullScreen(state) {
      return state.isFullScreen;
    }
  },

  mutations: {
    updateLoggedInUser(state, user) {
      state.loggedInUser = user
    },
    setGame(state, currentGame) {
      state.currentGame = currentGame
    },
    updateCurrentRound(state, currentRound) {
      // @ts-ignore TODO Add as Typescript and REMOVE this line
      state.currentGame.currentRound = currentRound
    },
    setFullScreen(state, isFullScreen: boolean) {
      state.isFullScreen = isFullScreen
    }
  }
});

